(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-iglike-lite"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const iglikeModal = document.getElementById("IglikeVideoModal");
  let iglikeModalSwiper = null;

  if (!iglikeModal || typeof Swiper === "undefined") return;

  function playVideoInSlide(swiper) {
    swiper.slides.forEach(function (slide, index) {
      const video = slide.querySelector("video");
      if (video) {
        if (index === swiper.activeIndex) {
          video.currentTime = 0;
          video.play().catch(function (err) {
            console.warn("再生できません:", err);
          });
        } else {
          video.pause();
          video.currentTime = 0;
        }
      }
    });
  }

  function stopAllVideos() {
    document.querySelectorAll(".iglike-modal video").forEach(function (video) {
      video.pause();
      video.currentTime = 0;
    });
  }

  function openIglikeModal(index) {
    iglikeModal.classList.add("show");
    iglikeModalSwiper.slideTo(index, 0);
    setTimeout(function () {
      playVideoInSlide(iglikeModalSwiper);
    }, 30);
  }

  if (document.querySelector(".iglike-item-slider")) {
    new Swiper(".iglike-item-slider", {
      slidesPerView: 5,
      spaceBetween: 20,
      speed: 600,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: ".iglike-swiper-button-next",
        prevEl: ".iglike-swiper-button-prev",
      },
      pagination: {
        el: ".iglike-swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: 20,
        },
      },
      on: {
        init: function () {
          this.el.classList.remove("iglike-item-slider__pre-init");
        },
      },
    });
  }

  iglikeModalSwiper = new Swiper(".iglike-modal-swiper", {
    direction: "vertical",
    spaceBetween: 10,
    navigation: {
      nextEl: ".iglike-modal-next",
      prevEl: ".iglike-modal-prev",
    },
    mousewheel: true,
    on: {
      slideChangeTransitionEnd: function (swiper) {
        playVideoInSlide(swiper);
      },
    },
  });

  document.querySelectorAll(".iglike-mov-thumbnail").forEach(function (thumb, index) {
    thumb.addEventListener("click", function () {
      openIglikeModal(index);
    });
  });

  document.querySelectorAll(".iglike-modal-close").forEach(function (btn) {
    btn.addEventListener("click", function () {
      iglikeModal.classList.remove("show");
      stopAllVideos();
    });
  });

  iglikeModal.addEventListener("click", function (e) {
    if (e.target === iglikeModal) {
      iglikeModal.classList.remove("show");
      stopAllVideos();
    }
  });

  const miniPlayerEl = document.getElementById("IglikeMiniPlayer");
  const miniPlayerVideo = document.getElementById("IglikeMiniPlayerVideo");
  const miniPlayerClose = document.getElementById("IglikeMiniPlayerClose");
  const miniPlayerDataEl = document.getElementById("IglikeMiniPlayerData");

  if (miniPlayerEl && miniPlayerVideo && miniPlayerDataEl) {
    let miniVideoUrls = [];

    try {
      miniVideoUrls = JSON.parse(miniPlayerDataEl.textContent).filter(Boolean);
    } catch (e) {
      console.warn("ミニプレーヤー: 動画データの解析に失敗しました", e);
    }

    if (miniVideoUrls.length > 0) {
      let miniCurrentIndex = 0;
      let miniDismissed = false;

      function miniPlayAt(index) {
        miniPlayerVideo.src = miniVideoUrls[index];
        miniPlayerVideo.load();
        miniPlayerVideo.play().catch(function (err) {
          console.warn("ミニプレーヤー: 再生できません:", err);
        });
      }

      miniPlayerVideo.addEventListener("ended", function () {
        if (miniVideoUrls.length > 1 && miniCurrentIndex < miniVideoUrls.length - 1) {
          miniCurrentIndex++;
        } else if (miniVideoUrls.length > 1) {
          miniCurrentIndex = 0;
        }
        miniPlayAt(miniCurrentIndex);
      });

      miniPlayerVideo.addEventListener("pause", function () {
        if (!miniDismissed && miniPlayerVideo.src && !miniPlayerVideo.ended) {
          miniPlayerVideo.play().catch(function () {});
        }
      });

      function dismissMiniPlayer() {
        miniDismissed = true;
        miniPlayerEl.classList.remove("is-visible");
        miniPlayerEl.addEventListener("transitionend", function handler() {
          miniPlayerEl.classList.add("is-hidden");
          miniPlayerVideo.pause();
          miniPlayerVideo.removeAttribute("src");
          miniPlayerVideo.load();
          miniPlayerEl.removeEventListener("transitionend", handler);
        });
      }

      miniPlayerClose.addEventListener("click", function (e) {
        e.stopPropagation();
        dismissMiniPlayer();
      });

      miniPlayerEl.addEventListener("click", function () {
        const targetIndex = miniCurrentIndex;
        dismissMiniPlayer();
        openIglikeModal(targetIndex);
      });

      miniPlayerVideo.addEventListener("loadeddata", function handler() {
        miniPlayerVideo.removeEventListener("loadeddata", handler);
        requestAnimationFrame(function () {
          miniPlayerEl.classList.add("is-visible");
        });
      });

      miniPlayAt(miniCurrentIndex);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
